import { Api } from '@evidence/sdk'

export class CslStyleApi {
  constructor(private _reviewManagerService: Api<unknown>) {}
  async find(): Promise<string[]> {
    const { data } =
      await this._reviewManagerService.api.cslStylesControllerFindCslStyles()
    return data
  }
}
